import { render, staticRenderFns } from "./ClientFile.vue?vue&type=template&id=5dcbe5ab&scoped=true"
import script from "./ClientFile.vue?vue&type=script&lang=js"
export * from "./ClientFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbe5ab",
  null
  
)

export default component.exports